import { render, staticRenderFns } from "./HiretechScreens.vue?vue&type=template&id=713fb0f4&scoped=true&"
import script from "./HiretechScreens.vue?vue&type=script&lang=js&"
export * from "./HiretechScreens.vue?vue&type=script&lang=js&"
import style0 from "./HiretechScreens.vue?vue&type=style&index=0&id=713fb0f4&scoped=true&lang=css&"
import style1 from "./HiretechScreens.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "713fb0f4",
  null
  
)

export default component.exports